import { render, staticRenderFns } from "./FilterItem.vue?vue&type=template&id=3c52b0a6&scoped=true"
import script from "./FilterItem.vue?vue&type=script&lang=js"
export * from "./FilterItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c52b0a6",
  null
  
)

export default component.exports